<template>
	<div>
		<div class="footer blocks">
			<div class="container fbox">
				<div class="copy">
					Copyright © Center for International Knowledge on
					Development, China. All Rights Reserved
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: {},
	data() {
		return {};
	},
	computed: {},
	watch: {},
	mounted() {},
	methods: {},
};
</script>
<style lang="less" scoped>
.footer {
	border-top: 10px solid #0072b5;
	height: 117px;
	.container {
		max-width: 1366px;
		margin: 30px auto 40px auto;
		.copy {
			color: #6e6f71;
			font-size: 16px;
			line-height: 28px;
			text-align: center;
		}
	}
}
</style>
